var x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var y = (x) => (() => (x))
const __WEBPACK_NAMESPACE_OBJECT__ = x({ ["useThree"]: () => (__WEBPACK_EXTERNAL_MODULE__react_three_fiber_04a29614__.useThree) });